export default {
    changeLogin (state, data) {
        state.LoginStatus = data
    },
    changeSub (state,data) {
        state.ShowSubContainer = data
    },
    changOrderId(state,data) {
        state.orderId = data
    }
 }


// WEBPACK FOOTER //
// ./src/store/mutations.js